export default __webpack_public_path__ + "static/media/chevron_red.65344167.svg";